import {getCurrentItem} from './getCurrentItem';
import {useStudentSelector} from './useStudentSelector';
import {isQuiz, isSequencedFlowItem} from '@ael/core-api';

export const useCanDisplayCongratulationsSelector = () => {
  const currentItem = useStudentSelector(getCurrentItem);
  const isQuizOrLinearFlowSelected = currentItem && (isQuiz(currentItem) || isSequencedFlowItem(currentItem));
  const isHotspotOpened = useStudentSelector((state) => state.currentHotspot.hotspot) !== null;

  return !isHotspotOpened && !isQuizOrLinearFlowSelected;
};
